<template>
    <div>
        <!-- NPS Breakdown Desktop -->
        <div class="card is-hidden-mobile is-hidden-tablet-only" data-track="NPS Breakdown - desktop">
            <header class="card-header is-hidden-mobile">
                <p class="card-header-title">NPS&nbsp;<span class="has-text-weight-normal">breakdown</span></p>
                <p class="card-header-icon has-text-weight-normal">
                    <drop-down place-holder="Filter by date..."
                               :items="filterList"
                               v-on:changed="npsFilterSelected"
                               :select-first-item-on-mount="true"></drop-down>
                </p>
            </header>
            <header class="card-header is-hidden-tablet">
                <p class="card-header-title">NPS&nbsp;<span class="has-text-weight-normal">breakdown</span></p>
                <p class="is-fullwidth">
                    <drop-down :is-full-width="true"
                               place-holder="Filter by date..."
                               :items="filterList"
                               v-on:changed="npsFilterSelected"
                               :select-first-item-on-mount="true"></drop-down>
                </p>
            </header>
            <div class="card-content">
                <div v-if="!isFetchingNPSTotals">
                    <div class="level mar-bottom">
                        <div class="level-item level-left">
                            <div class="nps-total" v-text="npsTotal"></div>
                        </div>
                        <div class="level-item">
                            <p class="has-text-weight-bold respondents is-size-2">
                                {{ npsRespondents }}
                                <br/><span class="is-size-6">RESPONSES</span>
                            </p>
                        </div>
                        <div class="level-item level-right">
                            <p class="nps-image detractors has-text-weight-bold" v-text="npsDetractors"></p>
                            <p class="nps-image passives has-text-weight-bold" v-text="npsPassives"></p>
                            <p class="nps-image promoters has-text-weight-bold" v-text="npsPromoters"></p>
                        </div>
                    </div>
                </div>
                <div v-if="isFetchingNPSTotals">
                    <p class="has-text-centered">
                        <img class="small-spinner" src="/static/img/loaders/spinner.svg" alt="fetching NPS Totals..."/>
                    </p>
                </div>
            </div>
        </div>

        <!-- NPS Breakdown Tablet and Mobile-->
        <div class="column is-full-tablet is-hidden-desktop">
            <div class="card" data-track="NPS Breakdown - touch">
                <header class="card-header is-hidden-mobile">
                    <p class="card-header-title">NPS&nbsp;<span class="has-text-weight-normal">breakdown</span></p>
                    <p class="card-header-icon has-text-weight-normal">
                        <drop-down place-holder="Filter by date..."
                                   :items="filterList"
                                   v-on:changed="npsFilterSelected"
                                   :is-full-width="true"
                                   :select-first-item-on-mount="true">
                        </drop-down>
                    </p>
                </header>
                <header class="card-header is-hidden-tablet">
                    <p class="card-header-title">NPS&nbsp;<span class="has-text-weight-normal">breakdown</span></p>
                    <p class="is-fullwidth">
                        <drop-down :is-full-width="true"
                                   place-holder="Filter by date..."
                                   :items="filterList"
                                   v-on:changed="npsFilterSelected"
                                   :select-first-item-on-mount="true">
                        </drop-down>
                    </p>
                </header>
                <div class="card-content">
                    <div v-if="!isFetchingNPSTotals">
                        <div class="level mar-bottom is-hidden-mobile">
                            <div class="level-item level-left">
                                <div class="nps-total" v-text="npsTotal"></div>
                            </div>
                            <div class="level-item">
                                <p class="has-text-weight-bold respondents is-size-2">{{ npsRespondents }}<br/><span class="is-size-6">RESPONSES</span></p>
                            </div>
                            <div class="level-item level-right">
                                <p class="nps-image detractors has-text-weight-bold" v-text="npsDetractors"></p>
                                <p class="nps-image passives has-text-weight-bold" v-text="npsPassives"></p>
                                <p class="nps-image promoters has-text-weight-bold" v-text="npsPromoters"></p>
                            </div>
                        </div>
                        <!-- MOBILE ONLY -->
                        <div class="columns is-mobile is-hidden-tablet">
                            <div class="column is-4 is-offset-1">
                                <div class="nps-total" v-text="npsTotal"></div>
                            </div>
                            <div class="column is-offset-1">
                                <p class="has-text-weight-bold respondents is-size-2">{{ npsRespondents }}<br/><span class="is-size-6">RESPONSES</span></p>
                            </div>
                        </div>
                        <div class="columns is-mobile is-hidden-tablet">
                            <div class="column">
                                <p class="nps-image detractors has-text-weight-bold" v-text="npsDetractors"></p>
                            </div>
                            <div class="column">
                                <p class="nps-image passives has-text-weight-bold" v-text="npsPassives"></p>
                            </div>
                            <div class="column">
                                <p class="nps-image promoters has-text-weight-bold" v-text="npsPromoters"></p>
                            </div>
                        </div>
                    </div>
                    <div v-if="isFetchingNPSTotals">
                        <p class="has-text-centered">
                            <img class="small-spinner" src="/static/img/loaders/spinner.svg" alt="fetching NPS Totals..." />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import DropDown from './DropDown.vue'
  import axios from 'axios'
  import misc from './../mixins/misc.js'
  import moment from 'moment'
  import qs from 'qs'

  export default {
    name: 'NPSTotals',
    components: {
      DropDown
    },
    mixins: [misc],
    data () {
      return {
        isFetchingNPSTotals: false,
        npsPromoters: 0,
        npsPassives: 0,
        npsDetractors: 0,
        npsRespondents: 0,
        npsTotal: 0,
        npsTotalUrl: ''
      }
    },
    methods: {
      npsFilterSelected (event) {
        const dateQuery = this.dateFilters(qs, moment, event.value)
        const npsTotalUrl = `/${this.businessSlug}/reports/nps-totals?${dateQuery}`
          if (npsTotalUrl !== this.npsTotalUrl) {
              this.npsTotalUrl = npsTotalUrl
              this.isFetchingNPSTotals = true
              axios.get(`/${this.businessSlug}/reports/nps-totals?${dateQuery}`)
                  .then(({data}) => {
                      this.npsPromoters = data.promoters
                      this.npsPassives = data.passives
                      this.npsDetractors = data.detractors
                      this.npsRespondents = data.totalRespondents
                      this.npsTotal = data.nps_total
                      this.isFetchingNPSTotals = false
                  })
                  .catch(() => {
                      this.isFetchingNPSTotals = false
                      flash('We encountered a problem retrieving your NPS data, please try again later', 'is-danger')
                  })
          }
      }
    },
    created () {
      this.businessSlug = localStorage.getItem('org_slug')
      this.updateFilterList()
    }
  }
</script>
<style scoped>

    .small-spinner {
        max-width: 40px!important;
    }

    .nps-image {
      display: block;
      min-width: 50px;
      height: 75px;
      text-align: center;
      background-size: 50px 50px;
      padding-top: 52px;
    }

    .passives {
        margin-left: 20px;
        margin-right: 20px;
    }

    .respondents {
        line-height: 1.6rem;
    }

    .nps-total {
        display: block;
        width: 105px;
        height: 105px;
        border: 5px solid #2FABE1;
        border-radius: 50%;
        font-size: 2.2rem;
        text-align: center;
        line-height: 95px;
        font-weight: bold;
    }

    @media screen and (max-width: 767px) {
        .respondents {
            height: 105px;
            padding-top: 25px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/NPSTotals.vue